module.exports = __webpack_public_path__ + "static/Tech-desktop-d927aad8a089895680a56f9801b8fdf5.png";